<template>
  <div class="post" :id="post.id">
    <div class="post-title">{{ post.title.rendered }}</div>
    <div class="post-meta">
      By
      <span class="highlight">{{ name }}</span> on
      <span class="highlight">{{ date }}</span>
    </div>
    <div class="post-excerpt post-data" v-if="card">
      <span v-html="post.excerpt.rendered"></span>
      <div class="post-expand" v-on:click="card=false">Read More</div>
    </div>
    <div class="post-content post-data" v-else>
      <span v-html="post.content.rendered"></span>
      <div class="post-expand" v-on:click="card=true">Read Less</div>
    </div>
  </div>
</template>
    
<script>
import { Post } from "../models/BlogModel";

export default {
  name: "Post",
  props: {
    post: Post,
    card: Boolean
  },
  data() {
    return {
      name: "",
      categories: [],
      date: ""
    };
  },
  mounted() {
    this.date = new Date(this.post.date).toDateString();
    fetch(
      "https://nateintolubbe.appspot.com/wp-json/wp/v2/users/" +
        this.post.author
    )
      .then(r => r.json())
      .then(res => (this.name = res.name));
  }
};
</script>

<style lang="scss">
.highlight {
  color: #ff9800;
  font-weight: 600;
}
.post {
  flex-grow: 1;
  width: 60%;
  margin: 0px auto;
  padding: 15px;
  background-color: #efefef;
  color: #3e3e3e;
  box-shadow:
    /* The top layer shadow */ 0 -1px 1px rgba(0, 0, 0, 0.15),
    /* The second layer */ 0 -10px 0 -5px #eee,
    /* The second layer shadow */ 0 -10px 1px -4px rgba(0, 0, 0, 0.15),
    /* The third layer */ 0 -20px 0 -10px #eee,
    /* The third layer shadow */ 0 -20px 1px -9px rgba(0, 0, 0, 0.15);
}
.post-data {
  text-align: left;
}
.post-meta {
  margin-top: 8px;
  margin-bottom: 8px;
}
.post-title {
  font-size: 20pt;
  font-style: italic;
  font-weight: 400;
}

.post-expand {
  color: #ff9800;
  font-weight: 600;
  margin-top: 8px;
  margin-bottom: 8px;
  text-align: center;
}
</style>